import useAuthUser from "react-auth-kit/hooks/useAuthUser";
import { UserRole } from "types";

const useRole = (): UserRole | undefined => {
  const userProfile = useAuthUser<any>();
  return userProfile ? userProfile.userRole : undefined;
};

export default useRole;
